// Nairobi excursions — real catalogue from the client's "Nairobi Excursions 2024"
// rate sheet (prices are the client's Nett rates, published as-is per Alex 2026-08-03).
// Adult price = startingPrice; childPrice = under-12 rate. Pending: photos.
const MEETING = 'Pick-up & drop-off at your Nairobi hotel';

export const nairobi = {
  slug: 'nairobi',
  name: 'Nairobi',
  title: 'Nairobi Excursions',
  tagline: 'Wildlife, culture, hikes and day trips from Kenya’s capital',
  intro:
    'Nairobi is the only capital on earth with a national park on its doorstep — and the perfect base for day trips. Meet orphaned elephants and endangered giraffes, step into the world of Out of Africa in Karen, hike the Rift Valley volcanoes, or head out to Amboseli, Lake Naivasha and Ol Pejeta. Every excursion below includes hotel pick-up and a professional guide.',
  heroImage: '/Images/excursions/nairobi-city-tour.webp',
  pricingPending: false,
  excursions: [
    {
      id: 'JTHEN002',
      slug: 'nairobi-national-park',
      title: 'Nairobi National Park Tour',
      category: 'Nature & Wildlife',
      teaser: "The world's only national park bordering a capital — spot the Big Five (bar elephants) against the skyline.",
      description:
        'A half-day game drive through the unique wildlife sanctuary on the edge of Nairobi — the only park in Africa adjacent to a capital city. You can see most of the Big Five (except elephants), plus giraffe, zebra, buffalo and one of Kenya’s densest black rhino populations, all with the city skyline behind them.',
      duration: '4 hours',
      startingPrice: 120,
      childPrice: 100,
      currency: 'USD',
      highlights: ['Big game minutes from the city', 'Black rhino sanctuary', 'Morning or afternoon game drive'],
      included: ['Park entry fees', 'Game drive', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/nairobi-national-park.webp'],
    },
    {
      id: 'JTHEN003',
      slug: 'karen-blixen-giraffe-centre-kazuri',
      title: 'Karen Blixen Museum, Giraffe Centre & Kazuri Beads',
      category: 'Cultural & City',
      featured: true,
      teaser: 'Out of Africa country — hand-feed giraffes, tour Karen Blixen’s farm, and watch Kazuri’s bead artisans at work.',
      description:
        'A half-day tour at the foot of the Ngong Hills. Visit the Karen Blixen Museum — the farmhouse of Isak Dinesen of Out of Africa fame — then the Giraffe Centre, home of the endangered Rothschild’s giraffe you can hand-feed from a raised platform. Finish at the Kazuri Bead Factory (kazuri means "beautiful" in Swahili), where you’ll see local women shape and paint each bead by hand.',
      duration: '4 hours',
      startingPrice: 75,
      childPrice: 60,
      currency: 'USD',
      highlights: ["Hand-feed Rothschild's giraffes", 'Karen Blixen Museum (Out of Africa)', 'Kazuri bead artisans'],
      included: ['Entry to Karen Blixen Museum & Giraffe Centre', 'Free entry to Kazuri Beads', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/karen-giraffe.webp', '/Images/excursions/karen-blixen.webp', '/Images/excursions/kazuri-beads.webp'],
    },
    {
      id: 'JTHEN001',
      slug: 'nairobi-city-tour',
      title: 'Nairobi City Tour',
      category: 'Cultural & City',
      teaser: 'The city centre, markets, Parliament, the National Museum & Snake Park in half a day.',
      description:
        'A half-day tour of Kenya’s capital covering the modern city centre, the colourful markets, the Parliament buildings, the 1998 bomb-blast memorial and the renowned National Museum — with its spellbinding displays of tribal regalia, early man, and Kenya’s flora and fauna — plus the adjacent Snake Park.',
      duration: '3 hours',
      startingPrice: 60,
      childPrice: 50,
      currency: 'USD',
      highlights: ['National Museum & Snake Park', 'City centre & markets', 'Parliament & memorial'],
      included: ['Entrance fees to National Museum, Snake Park & Railway Museum', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/nairobi-city-tour.webp'],
    },
    {
      id: 'JTHEN005',
      slug: 'bomas-of-kenya',
      title: 'Bomas of Kenya',
      category: 'Cultural & City',
      teaser: 'Traditional music and dance across recreated homesteads of Kenya’s many communities.',
      description:
        'Just outside the city centre, Bomas of Kenya recreates the traditional villages (bomas) of Kenya’s diverse communities. Take a guided tour of the homesteads, then enjoy a spectacular afternoon display of traditional dance, music and folklore in the arena.',
      duration: '3 hours',
      startingPrice: 85,
      childPrice: 55,
      currency: 'USD',
      highlights: ['Traditional dance & music show', 'Recreated homesteads', 'Kenya’s many cultures'],
      included: ['Entry fees to Bomas of Kenya', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/bomas-of-kenya.webp'],
    },
    {
      id: 'JTHEN006',
      slug: 'carnivore-experience',
      title: 'The Carnivore Experience (Lunch or Dinner)',
      category: 'Dining & Entertainment',
      teaser: '“Africa’s greatest eating experience” — endless barbecue meats, including wild game.',
      description:
        'Lunch or dinner at the world-famous Carnivore Restaurant — often called "Africa’s greatest eating experience." Every kind of barbecue meat imaginable is carved at your table, including four choices of wild game. Transport-inclusive and transport-only options available.',
      duration: '2.5 hours',
      startingPrice: 60,
      childPrice: null,
      currency: 'USD',
      highlights: ['All-you-can-eat barbecue', 'Wild-game choices', 'Lunch or dinner sitting'],
      included: ['Meal at The Carnivore', 'Hotel transport (transport-inclusive option)'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/carnivore-experience.webp'],
    },
    {
      id: 'JTNO007',
      slug: 'nairobi-guided-walking-tour',
      title: 'Nairobi Highlight Guided Walking Tour',
      category: 'Cultural & City',
      teaser: 'A bird’s-eye view from the KICC rooftop, then a walking tour of the city’s landmarks and markets.',
      description:
        'Start atop the 28-storey Kenyatta International Convention Centre (KICC) for an unrivalled 360° view of Nairobi — on a clear day you can pick out Uhuru Park and even Nairobi National Park. Then walk the bustling city centre: the Kenyatta Mausoleum, Parliament, the Kenya National Archives, the historic "Thorn Tree," and the City or Maasai markets, where your guide helps you bargain.',
      duration: '4 hours',
      startingPrice: 75,
      childPrice: 50,
      currency: 'USD',
      highlights: ['KICC rooftop 360° view', 'City-centre landmarks', 'Local craft markets'],
      included: ['Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Lunch (own expense)', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/nairobi-walking-tour.webp'],
    },
    {
      id: 'JTHEN004',
      slug: 'lake-naivasha-hells-gate',
      title: "Lake Naivasha & Hell's Gate Day Trip",
      category: 'Nature & Wildlife',
      teaser: 'A boat ride on Lake Naivasha, Crescent Island, and a walk or cycle through Hell’s Gate.',
      description:
        'A full day in the Great Rift Valley. Take a boat ride on Lake Naivasha with a visit to Crescent Island, enjoy lunch at a lakeside lodge, then head to Hell’s Gate National Park — famous for its towering cliffs and gorges, where you can walk or cycle among zebra, giraffe and antelope. Return to Nairobi in the evening.',
      duration: '8 hours',
      startingPrice: 215,
      childPrice: 185,
      currency: 'USD',
      highlights: ['Lake Naivasha boat ride', 'Crescent Island', "Hell's Gate cliffs & wildlife"],
      included: ["Hell's Gate park fees", 'Boat ride + Crescent Island', 'Lunch boxes', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/lake-naivasha.webp', '/Images/excursions/hells-gate.webp'],
    },
    {
      id: 'JTHA005',
      slug: 'amboseli-day-tour',
      title: 'Amboseli Day Tour from Nairobi',
      category: 'Safari Adventures',
      teaser: 'Great elephant herds beneath Mount Kilimanjaro — a full-day safari from Nairobi.',
      description:
        'An early departure from Nairobi to Amboseli National Park, famed for its large elephant herds and classic views of Mount Kilimanjaro rising across the border. Enjoy game drives and a picnic lunch before returning to Nairobi in the evening.',
      duration: 'Full day',
      startingPrice: 235,
      childPrice: 215,
      currency: 'USD',
      highlights: ['Large elephant herds', 'Kilimanjaro views', 'Full-day game drives'],
      included: ['Park entry fees', 'Lunch boxes', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/amboseli-daytrip.webp'],
    },
    {
      id: 'JTHO006',
      slug: 'ol-pejeta-chimpanzee-sanctuary',
      title: 'Ol Pejeta Conservancy & Chimpanzee Sanctuary',
      category: 'Safari Adventures',
      teaser: 'Big-game game drive plus East Africa’s only chimpanzee sanctuary, on the equator in Laikipia.',
      description:
        'A full day at Ol Pejeta Conservancy in Laikipia — a not-for-profit sanctuary between the Aberdares and Mount Kenya, home to the Big Five and the last northern white rhinos. Enjoy a game drive and visit the Sweetwaters Chimpanzee Sanctuary before returning to Nairobi.',
      duration: 'Full day',
      startingPrice: 250,
      childPrice: 230,
      currency: 'USD',
      highlights: ['Big-game game drive', 'Chimpanzee sanctuary', 'Rhino conservation'],
      included: ['Park entry fees', 'Lunch boxes', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/ol-pejeta.webp', '/Images/excursions/chimpanzee-sanctuary.webp'],
    },
    {
      id: 'JTNL09',
      slug: 'mount-longonot-day-hike',
      title: 'Mount Longonot Day Hike',
      category: 'Adventure & Hiking',
      teaser: 'Hike the crater rim of a Rift Valley stratovolcano above Lake Naivasha.',
      description:
        'A full-day hike up Mount Longonot, a stratovolcano south-east of Lake Naivasha whose name comes from the Maasai for "mountain of many spurs." Climb to the crater rim for sweeping Rift Valley views, with lunch boxes provided, then return to Nairobi in the evening.',
      duration: '8 hours',
      startingPrice: 150,
      childPrice: 140,
      currency: 'USD',
      highlights: ['Crater-rim hike', 'Rift Valley views', 'Lunch boxes included'],
      included: ['Park entrance fees', 'Lunch boxes', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/mount-longonot.webp'],
    },
    {
      id: 'JTNN010',
      slug: 'ngong-hills-day-hike',
      title: 'Ngong Hills Day Hike',
      category: 'Adventure & Hiking',
      teaser: 'Ridge-line walk over the iconic Ngong Hills, 25km from the city.',
      description:
        'A half-day hike across the Ngong Hills Forest, 25km from Nairobi in Kajiado County. Walk the scenic ridge-line through indigenous and exotic forest — home to buffalo, wild pigs, porcupine and dik-dik — with a picnic lunch along the way.',
      duration: '6 hours',
      startingPrice: 120,
      childPrice: 115,
      currency: 'USD',
      highlights: ['Iconic ridge-line walk', 'Forest wildlife', 'Picnic lunch'],
      included: ['Park entrance fees', 'Picnic lunch', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/ngong-hills.webp'],
    },
    {
      id: 'JTNM011',
      slug: 'masai-village-tour',
      title: 'Masai Village Half Day Tour',
      category: 'Unique Local Experiences',
      teaser: 'Visit a Maasai manyatta near Nairobi — culture, dance and handmade crafts.',
      description:
        'A half-day trip to a Maasai village (manyatta) in the Ngong or Athi River area. Meet the Maasai, learn about their culture and traditional dances, and browse handmade artefacts.',
      duration: '4 hours',
      startingPrice: 88,
      childPrice: 88,
      currency: 'USD',
      highlights: ['Maasai culture & dance', 'Manyatta visit', 'Handmade crafts'],
      included: ['Village visit fees', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Drinks', 'Food', 'Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/masai-village.webp'],
    },
    {
      id: 'JTNK012',
      slug: 'kiambethu-tea-farm',
      title: 'Kiambethu Tea Farm Half Day Tour',
      category: 'Unique Local Experiences',
      teaser: 'Tea history and tasting on a working farm, an indigenous-forest walk, and a farm-to-table lunch.',
      description:
        'A half-day at the historic Kiambethu Tea Farm. Over a cup of tea, hear the story of the farm and how tea is made, then see it growing in the field. Walk the indigenous forest with a resident guide — watch for colobus monkeys — before a three-course buffet lunch on the verandah, overlooking the tea fields to the Ngong Hills.',
      duration: '4 hours',
      startingPrice: 115,
      childPrice: 100,
      currency: 'USD',
      highlights: ['Tea history & tasting', 'Indigenous forest walk', 'Farm-to-table lunch'],
      included: ['Farm tour', 'Tea/coffee', 'Lunch at the farm', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/kiambethu-tea-farm.webp'],
    },
    {
      id: 'JTNK012b',
      slug: 'experiential-coffee-farm',
      title: 'Experiential Coffee Farm Tour',
      category: 'Unique Local Experiences',
      teaser: 'From cherry to cup — tour a working coffee estate and roast your own beans.',
      description:
        'A half-day at Mbumi Coffee Estate. Walk the full journey from the tree nursery through picking, washing, drying, milling, grading and roasting — then roast your own coffee and enjoy a cup on the rooftop overlooking the farm. Immersive, educational and delicious.',
      duration: '4 hours',
      startingPrice: 120,
      childPrice: 110,
      currency: 'USD',
      highlights: ['Full coffee process', 'Roast your own beans', 'Rooftop farm views'],
      included: ['Farm tour', 'Tea/coffee at the farm', 'Professional guide', 'Hotel pick-up & drop-off'],
      excluded: ['Gratuities'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/coffee-farm.webp'],
    },
    {
      id: 'JTNO008',
      slug: 'nairobi-souvenir-tour',
      title: 'Nairobi Souvenir Half Day Tour',
      category: 'Unique Local Experiences',
      teaser: 'Shop the Maasai Market and see how Kazuri beads are made.',
      description:
        'A half-day shopping tour to the Maasai Market for souvenirs and crafts, plus a visit to Kazuri Beads to see how the beads are handmade, before returning to your hotel.',
      duration: '4 hours',
      startingPrice: 70,
      childPrice: 60,
      currency: 'USD',
      highlights: ['Maasai Market', 'Kazuri bead workshop', 'Souvenir shopping'],
      included: ['Professional driver/guide', 'Hotel pick-up & drop-off'],
      excluded: ['Food & drinks', 'Gratuities', 'Souvenir photos'],
      meetingPoint: MEETING,
      images: ['/Images/excursions/nairobi-souvenir.webp'],
    },
  ],
};
